import { Outlet } from 'react-router-dom'
import logoSvg from '@/assets/logo.svg'

export default function AuthLayout() {
    return (
        <div className="flex min-h-screen">
            {/* Left side - Branding */}
            <div className="hidden lg:flex lg:w-1/2 gradient-primary items-center justify-center p-12">
                <div className="max-w-md text-white">
                    <div className="flex items-center gap-3 mb-8">
                        <img src={logoSvg} alt="Keyframes" className="h-12 w-12" />
                        <span className="text-3xl font-bold">Keyframes</span>
                    </div>
                    <h1 className="text-4xl font-bold mb-4">
                        End-to-end animation project management
                    </h1>
                    <p className="text-lg opacity-90 mb-8">
                        From script to screen. Manage your entire animation pipeline with
                        collaborative tools designed for creative teams.
                    </p>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                        <div className="flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-white/80" />
                            <span>Script Writing</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-white/80" />
                            <span>Beat Boards</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-white/80" />
                            <span>Shot Management</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-white/80" />
                            <span>Real-time Collaboration</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right side - Auth forms */}
            <div className="flex flex-1 items-center justify-center p-8">
                <div className="w-full max-w-md">
                    {/* Mobile logo */}
                    <div className="flex lg:hidden items-center justify-center gap-2 mb-8">
                        <img src={logoSvg} alt="Keyframes" className="h-10 w-10" />
                        <span className="text-2xl font-bold">Keyframes</span>
                    </div>

                    <Outlet />
                </div>
            </div>
        </div>
    )
}
